module.exports = "'data:image/svg+xml;utf8,<svg width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\"><title>Slice 1</title><path d=\"M4.695 6.49L.715 2.51A1.128 1.128 0 0 1 .718.92 1.12 1.12 0 0 1 2.306.92l4.778 4.778c.216.216.325.502.326.79.003.291-.107.577-.326.796L2.306 12.06a1.128 1.128 0 0 1-1.588-.003 1.12 1.12 0 0 1-.003-1.588l3.98-3.98z\" fill=\"%2349B7FF\" fill-rule=\"evenodd\"/></svg>'"


//////////////////
// WEBPACK FOOTER
// ./src/Components/Toggle/arrowCollapsed.svg
// module id = 631
// module chunks = 0